export default __webpack_public_path__ + "static/media/patient1-big.3b8068c4.png";